const NotebookModule = () => import('@pages/management/notebook/NotebookModule')
const NotebookIndex = () => import('@pages/management/notebook/NotebookIndex')

export default {
    path: 'management',
    component: NotebookModule,
    children: [
        {
            path: 'notebook',
            component: NotebookIndex,
            name: 'managementNotebook',
        },
    ],
}
